import { useSelector } from 'react-redux'

import routes from '@tabeeb/routes'
import { getFormsTitle } from '@tabeeb/modules/appConfigState/selectors'

import NavbarTab from '../NavbarTab'

const Forms = ({ ...rest }) => {
  const formsTitle = useSelector(getFormsTitle)

  const props = {
    item: {
      label: formsTitle,
      to: Forms.to,
    },
    ...rest,
  }

  return <NavbarTab {...props} />
}

Forms.to = routes.forms

export default Forms
